import { render, staticRenderFns } from "./MC_Popup.vue?vue&type=template&id=014654f1&scoped=true"
import script from "./MC_Popup.vue?vue&type=script&lang=js"
export * from "./MC_Popup.vue?vue&type=script&lang=js"
import style0 from "./MC_Popup.vue?vue&type=style&index=0&id=014654f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014654f1",
  null
  
)

export default component.exports